import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { Shops } from '@/Swagger';
import { queryKeys } from '@/app/queryKeys';
import axiosInstance from '@/axios/axios';
import type { ExtractQueryFunction, UseAxiosQueryOptions } from '@/utils/typeHelper';

type QueryOptions = UseAxiosQueryOptions<Shops.NoticeList.ResponseBody, [string]>;

const queryFn: ExtractQueryFunction<QueryOptions> = () => {
  return axiosInstance.get<Shops.NoticeList.ResponseBody>('/shops/notice').then(v => v.data);
};

/**
 * 공지사항 조회하는 API 입니다.
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/App/get_shops_notice
 */
export function useGetNotice(options?: Partial<QueryOptions>) {
  return useQuery({ queryKey: [...queryKeys.notice] as const, queryFn, ...options });
}
/**
 * 공지사항 조회하는 API 입니다. (suspense hook)
 */
export function useSuspenseGetNotice(options?: QueryOptions) {
  return useSuspenseQuery({ queryKey: [...queryKeys.notice] as const, queryFn, ...options });
}
